import { useIsMutating, useQueryClient } from "@tanstack/react-query";

import { ReportReviewerStatus, useSetReportReviewStatusMutation } from "@api/graphql/types-and-hooks";
import { invalidateReportReviewers, settleReviewMutation } from "@components/QaReview/hooks/reviewMutations";
import { notifyError } from "@components/notifications/notifications";
import { useReport } from "@providers/ReportProvider";

export const useReviewStatus = () => {
  const queryClient = useQueryClient();
  const { report } = useReport();

  const mutation = useSetReportReviewStatusMutation({
    onError: () => notifyError("Error saving your review. Please try again."),
    onSuccess: async (data) => {
      const toasts = { failure: "Failed to save your review", success: "Review saved" };
      if (settleReviewMutation(data?.setReportReviewStatus, toasts)) await invalidateReportReviewers(queryClient);
    },
  });
  const isAnyStatusMutationPending = useIsMutating({ mutationKey: ["setReportReviewStatus"] }) > 0;

  return {
    isPending: isAnyStatusMutationPending,
    setStatus: (status: ReportReviewerStatus, { userId, note }: { userId?: string; note?: string } = {}) =>
      mutation.mutateAsync({ reportId: report.id, status, userId, note }),
  };
};
